import React from 'react';
import './ServiceLandscapeWhy.css';

const cards = [
  {
    number: '01',
    title: 'More time outside',
    description:
      'A well-designed outdoor space becomes a real part of your home. Somewhere you actually want to spend time, not somewhere you feel guilty about neglecting.',
  },
  {
    number: '02',
    title: "Built to last Colorado's seasons",
    description:
      "Every plant, material, and design decision is made with Colorado's climate in mind. What we install holds up through the heat, the cold, and everything in between.",
  },
  {
    number: '03',
    title: 'Value that shows',
    description:
      'A thoughtfully designed landscape adds real value to your property. More than that, it makes your home feel like a place people want to be.',
  },
];

const ServiceLandscapeWhy = () => (
  <section className="service-landscape-why">
    <div className="service-landscape-why__inner site-rail site-rail--wide">
      <header className="service-landscape-why__header">
        <span className="service-landscape-why__tag">WHY IT MATTERS</span>
        <h2 className="service-landscape-why__heading">
          A yard that works
          <span className="service-landscape-why__heading-accent"> for you</span>
        </h2>
      </header>

      <div className="service-landscape-why__cards">
        {cards.map(card => (
          <article key={card.number} className="service-landscape-why__card">
            <span className="service-landscape-why__card-number">{card.number}</span>
            <h3 className="service-landscape-why__card-title">{card.title}</h3>
            <p className="service-landscape-why__card-desc">{card.description}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default ServiceLandscapeWhy;
